const R = {
  Order: "ORDER",
  Subscription: "SUBSCRIPTION",
  SavedCard: "SAVED_CARD",
  Renewal: "RENEWAL",
  AutoRenewal: "AUTO_RENEWAL"
};
export {
  R as o
};
//# sourceMappingURL=RefType-9325c28c.mjs.map
